import { useHistory } from 'react-router-dom';
import { routes } from '../routes/routes';
import useApi from '../api';
import { useQuery } from 'react-query';
import queryConfig from '../util/queryConfig';
import Throbber from '../components/throbber/Throbber';
import Error from '../components/error/Error';
import { QueryKey } from '../constants/queryKey';

const ScenariosView = () => {
    const history = useHistory();
    const { getScenarios } = useApi();
    const { isLoading, error, data } = useQuery([QueryKey.Scenarios], async () => {
        const response = await getScenarios();
        return response.data;
    }, queryConfig);

    const onScenarioClick = (scenario) => {
        history.push(routes.scenario(scenario.scenario_id));
    }

    return (
        <div className="view">
            <h1 className="heading">Scenarios</h1>
            {isLoading ? (
                <Throbber title="Loading scenarios" />
            ) : error ? (
                <Error msg="Something went wrong loading scenarios. Please try again later." />
            ) : (
                <div className="cards">
                    {data?.scenarios?.length ? data.scenarios.map((scenario) => (
                        <div className="card" key={scenario.scenario_id} onClick={() => onScenarioClick(scenario)}>
                            <img className="card__thumbnail" src={scenario.thumbnail}
                                 alt={scenario.name} title={`scenario_id: ${scenario.scenario_id}`} />
                            <span className="state">{scenario.state}</span>
                            <h4 className="heading heading--sm">{scenario.name}</h4>
                            <p className="card__description">{scenario.remark}</p>
                            <p className="card__link">View details &rarr;</p>
                        </div>
                    )) : null}
                </div>
            )}
        </div>
    )
};

export default ScenariosView;
